import type { AccountingExpense } from 'types';
import {
  eventPaymentTypeLabel,
  eventPaymentTransactionLabel,
  type EventPaymentTransaction,
} from 'store/api/event/types';

const locationRentPattern = /location\s+rent/i;
const electricityPattern = /electric(?:ity)?|electric\s+socket/i;

const getEventAmount = (expense: AccountingExpense, eventId?: number) => {
  const eventAmount = expense.events?.find(
    (event) => Number(event.eventId) === Number(eventId)
  )?.amount;

  return Number(eventAmount ?? expense.amount ?? 0);
};

const getCategoryTransaction = (
  expense: AccountingExpense
): EventPaymentTransaction | undefined => {
  const categoryNames = expense.categories?.map((category) => category.name);
  const categoryText = categoryNames?.join(' ') ?? '';
  const notes = expense.description ?? '';

  if (locationRentPattern.test(categoryText)) {
    return /deposit/i.test(notes) ? 'deposit' : 'fullPayment';
  }

  if (electricityPattern.test(categoryText)) {
    return 'electricity';
  }

  return undefined;
};

export const getEventExpensePaymentRows = (
  expenses: AccountingExpense[] = [],
  eventId?: number
) =>
  expenses
    .map((expense) => {
      const transaction = getCategoryTransaction(expense);

      if (!transaction) {
        return null;
      }

      return {
        transaction,
        id: expense.id,
        date: expense.paymentDate,
        notes: expense.description,
        createdBy: expense.createdBy?.name,
        amount: getEventAmount(expense, eventId),
        paymentType: eventPaymentTypeLabel.payment,
        paymentMethod: expense.paymentMethod?.name,
        transactionLabel: eventPaymentTransactionLabel[transaction],
        paidBy: expense.employees
          ?.map((employee) => employee.user?.name)
          .filter(Boolean)
          .join(', '),
      };
    })
    .filter((row): row is NonNullable<typeof row> => Boolean(row));
